import React from 'react';
import { Template, TemplateGrid } from '../layouts/templates';
import MultiSlider from './MultiSlider';
import useTemplates from '../utils/useTemplates';

function getTemplates(templates, textColor, showDescriptions, asSlider) {
  if (!templates?.length > 0) return null;

  return templates.map(({ node }) => (
    <Template
      key={node.slug}
      node={node}
      textColor={textColor}
      showDescriptions={showDescriptions}
      asSlider={asSlider}
    />
  ));
}

export default function Templates(props) {
  const allTemplates = useTemplates();

  const filteredTemplates = allTemplates.edges
    .filter(({ node }) => {
      if (props.filter) return props.filter(node);
      if (props.slug !== 'all')
        return node.groups.find((x) => x.slug === props.slug);
      return node;
    })
    .slice(0, props.limit || 10);

  const templates = getTemplates(
    filteredTemplates,
    props.textColor,
    props.showDescriptions,
    props.asSlider,
  );

  return props.asSlider ? (
    <MultiSlider textColor={props.textColor} hasButton={props.hasButton}>
      {templates}
    </MultiSlider>
  ) : (
    <TemplateGrid>{templates}</TemplateGrid>
  );
}
